import Modernizr from 'modernizr'
import ImagesLoaded from 'imagesloaded'
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import SmoothScroll from 'smooth-scroll'
import Aos from 'aos'
import Validation from 'jquery-validation'

$(() => {

  // initialize
  let init = function() {
    pullDownMenu()
    drawerMenu()
    pageTopButton()
  }

  // change viewport
  const ua = navigator.userAgent
  if ((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
    $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">')
  } else {
    $('head').prepend('<meta name="viewport" content="width=1040">')
  }

  // pull down menu
  const pullDownMenu = function() {
    const parentClassName = '.globalNav__list > .menu-item-has-children',
          childClassName  = '.sub-menu'
    $(parentClassName + ' > ' + childClassName)
      .hide()
      .css('opacity', 1) // ロード時のちらつき防止
    $(parentClassName).hover(
      function() {
        const parentPositionX = $(this).offset().left, // 要素のX座標
              parentPositionY = $(this).offset().top // 要素のY座標
                              + $(this).outerHeight() // 要素の高さ
                              - $(window).scrollTop(), // スクロール分を除算(追従時対応)
              windowWidth     = window.innerWidth
        $(this).children(childClassName).fadeIn(200)
        // 画面右端に差し掛かったときの調整
        const childWidth = $(this).children(childClassName).outerHeight() // 子要素の幅取得
        if(parentPositionX + childWidth > windowWidth) {
          $(this).children(childClassName)
            .css('right', 0)
        }
      },
      function() {
        $(this).children(childClassName).fadeOut(100)
      },
    )
  }

  // drawer menu
  function drawerMenu() {
    const drawerElement       = $('.js-drawer'),
          drawerButtonElement = $('.js-drawer-button'),
          openClassName       = 'open'
    drawerElement.hide()
    let headerHeight = $('.js-header').innerHeight()
    drawerElement.css('padding-top', headerHeight)
    drawerButtonElement.on('click', function(e) {
      if(drawerElement.hasClass(openClassName)) {
        drawerElement.css('opacity', 0).fadeOut(300);
      } else {
        drawerElement.css('opacity', 1).fadeIn(300);
      }
      drawerElement.toggleClass(openClassName)
      drawerButtonElement.toggleClass(openClassName)
      $('body').toggleClass(openClassName)
    })
  }

  // fixed header
  $(window).on('load resize scroll', function () {
    let windowHeight   = $(window).scrollTop(),
        headerElement  = $('.js-header'),
        activeClassName = ('is-fixed')
    if (windowHeight > 100) {
      headerElement.addClass(activeClassName);
    } else {
      headerElement.removeClass(activeClassName);
    }
  })

  // dropdown
  $('.js-dropdown').on('click', function() {
    $(this).toggleClass('open')
  })

  // Swiperモジュールの有効化
  Swiper.use([Navigation, Pagination, Autoplay]);

  // 対象ID・クラス名
  const swiperTargetClassNames = [
    'js-swiper-main-visual',
    'js-swiper-lead-items',
  ]
  // オプション
  const swiperOptions = {
    'js-swiper-main-visual': {
      loop: true,
      autoplay: {
        delay: slideDelayTime,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      speed: 600,
      pagination: {
        el: ".js-swiper-pagination-mainvisual",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-swiper-button-next",
        prevEl: ".js-swiper-button-prev",
      },
    },
    'js-swiper-lead-items': {
      allowTouchMove: false,
      loop: false,
      loopAdditionalSlides: 3,
      slidesPerView: 'auto',
      spaceBetween: 20,
      speed: 300,
      navigation: {
        prevEl: ".js-swiper-button-prev-items",
        nextEl: ".js-swiper-button-next-items",
      },
      breakpoints: {
        540: {
          allowTouchMove: true,
          spaceBetween: 32,
        }
      }
    },
  }
  for(let i = 0; i < swiperTargetClassNames.length; i++) {
    const swiper = new Swiper(
      '.'+swiperTargetClassNames[i],
      swiperOptions[swiperTargetClassNames[i]]
    );
  }

  // pagetop button
  const pageTopButton = function() {
    let TARGET_ELEMENT = $('.js-pageToTop'),
        SHOW_CLASS     = 'show',
        SHOW_POSITION    = 800
    $(window).on('scroll', function() {
      let windowScrollTop = $(this).scrollTop()
      if(windowScrollTop > SHOW_POSITION) {
        TARGET_ELEMENT.addClass(SHOW_CLASS)
      } else {
        if (TARGET_ELEMENT.hasClass(SHOW_CLASS)) {
          TARGET_ELEMENT.removeClass(SHOW_CLASS)
        }
      }
    })
  }

  // smooth scroll
  let scroll = new SmoothScroll('a[href*="#"]', {
    header: '[data-scroll-header]',
    speedAsDuration: true,
    speed: 1000,
    easing: 'easeInOutQuint',
    // ヘッダーの高さ分を調整
    offset: function(anchor, toggle) {
      var headerHeight = document.querySelector('.js-header').offsetHeight;
      return headerHeight;
    }
  });

  // scroll animation
  Aos.init({
    disable: false,
    offset: 120,
    delay: 0,
    duration: 1000,
    easing: 'ease'
  })

  // privacy checkbox
  $('.js-privacy-checkbox').change(function() {
    const is_checked    = $(this).prop('checked'),
          confirmButton = $('.js-confirm-button'),
          disabledClass = 'button--disabled'
    if($(this).prop('checked')) {
      confirmButton.removeClass(disabledClass).removeAttr('disabled', 'disabled')
    } else if(is_checked === false) {
      confirmButton.addClass(disabledClass).attr('disabled', 'disabled')
    }
  })

  // validation
  $.validator.addMethod(
    "kana",
    function (value, element) {
      return this.optional(element) || /^[ぁ-んーァ-ヾｦ-ﾟ０-９－\s　！”＃＄％＆’（）＝～｜‘｛＋＊｝＜＞？＿＾￥＠「；：」、。・]+$/.test(value);
    },
    "ひらがな、もしくはカタカナで入力してください"
  )
  $(".js-contactForm").validate({
    rules: {
      your_name: {
        required: true,
      },
      your_name_kana: {
        required: true,
        kana: true,
      },
      company_name: {
      },
      mail: {
        required: true,
        email: true,
      },
      tel: {
      },
      content: {
        required: true,
      },
      privacy: {
        required: true,
      },
    },
    messages: {
      your_name: {
        required: "入力必須項目です",
      },
      your_name_kana: {
        required: '入力必須項目です',
      },
      company_name: {
      },
      mail: {
        required: '入力必須項目です',
        email: 'メールアドレスの形式が正しくありません',
      },
      tel: {
      },
      content: {
        required: '入力必須項目です',
      },
      privacy: {
        required: '入力必須項目です',
      },

    },
    errorClass: "errorMessage",
  })

  init()

})

// mainvisual animation
$(window).on('load scroll', function() {
  let elem = $('.slideAnim__inner')
  elem.each(function () {
    let isPlay = 'isPlay'
    if (!$('.mainVisual__texts').hasClass('unfilled')) {
      $(this).addClass(isPlay)
    }
  })
})



// WEBPACK FOOTER //
// ./src/assets/js/scripts.js